import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CursorFollower = () => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const smoothX = useSpring(x, { damping: 25, stiffness: 200 });
  const smoothY = useSpring(y, { damping: 25, stiffness: 200 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [x, y]);

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      {/* Vertical line */}
      <motion.div
        className="absolute top-0 w-px h-full bg-white/20"
        style={{
          left: smoothX,
          transform: "translateX(-50%)"
        }}
      />
      
      {/* Horizontal line */}
      <motion.div
        className="absolute left-0 h-px w-full bg-white/20"
        style={{
          top: smoothY,
          transform: "translateY(-50%)"
        }}
      />
      
      {/* Center circle */}
      <motion.div
        className="absolute w-16 h-16 border border-white/20 rounded-full bg-white/5"
        style={{
          left: smoothX,
          top: smoothY,
          transform: "translate(-50%, -50%)"
        }}
      />
    </div>
  );
};

export default CursorFollower;